import { WageAndTravelReimbursementRequestStatus } from "../enums";

export interface IWageAndTravelRequestWeek {
    requestId: number, 
    week: number, 
    status: WageAndTravelReimbursementRequestStatus,
    otherAmount?: number,
    additionalWeeksDrSignOff?: string,
    additionalWeeksReason?: number,
    additionalWeeksReasonOther?: string,
    additionalWeeksJobDescription?: string,
    additionalWeeksComplications?: string,
    policyOrganType?: number
}

export interface IPhysicianLetterWeekUpload {
    requestId: number,
    week: number,
    documentType: 'complicationsReport',
    file: File,
    attested: boolean
}